import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CandlestickChart, Menu, X } from "lucide-react";

const LINKS = [
  { to: "/about", label: "Chi Siamo", testid: "pub-nav-about" },
  { to: "/trading", label: "NFP", testid: "pub-nav-trading" },
  { to: "/championship", label: "Championship", testid: "pub-nav-championship" },
  { to: "/lottery", label: "Lotteria", testid: "pub-nav-lottery" },
  { to: "/contact", label: "Contatti", testid: "pub-nav-contact" },
];

export default function PublicNav() {
  const loc = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-black/60 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="public-logo" className="flex items-center gap-2">
          <CandlestickChart size={22} className="text-blue-500" strokeWidth={2.5} />
          <span className="font-bold tracking-tight text-lg">Raein<span className="text-blue-500">Exchange</span></span>
        </Link>

        <nav className="hidden sm:flex items-center gap-6">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} data-testid={l.testid}
              className={`text-sm font-medium transition-colors ${loc.pathname === l.to ? "text-white" : "text-zinc-400 hover:text-white"}`}>
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link data-testid="public-login-btn" to="/auth"
            className="hidden sm:inline-flex text-sm font-medium px-4 py-2 rounded-md bg-white text-black hover:bg-zinc-200 transition-colors">
            Accedi
          </Link>
          <button className="sm:hidden p-2 text-zinc-300" onClick={() => setOpen(!open)} data-testid="public-menu-toggle">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="sm:hidden border-t border-white/10 px-6 py-4 flex flex-col gap-3 bg-black/80">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-sm text-zinc-300 hover:text-white">{l.label}</Link>
          ))}
          <Link to="/auth" onClick={() => setOpen(false)} className="text-sm font-medium text-blue-400">Accedi</Link>
        </div>
      )}
    </header>
  );
}
